import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseIngredients() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
    };

    setter(errorState);

    if (errorState.faName || errorState.enName) {
      enqueueSnackbar("لطفا اطلاعات ترکیبات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }
  function validateTransfer(state, setter) {
    let errorState = {
      transferID: isEmpty(state.transferID),
    };

    setter(errorState);

    if (errorState.transferID) {
      enqueueSnackbar("لطفا کد مورد نظر جهت انتقال را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getIngredientList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Ingredients?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllIngredientList = (search, callback) => {
    MyAxios.get(`Admin_Ingredients?w=${search}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getIngredientByID = (id, callback) => {
    MyAxios.get(`Admin_Ingredients/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateIngredient = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Ingredients`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ترکیبات با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addIngredient = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Ingredients`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ترکیبات با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const TransferIngredient = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Ingredients/Transfer`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ترکیبات با موفقیت منتقل شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteIngredient = (id, callback) => {
    const data = new FormData();
    data.append("IngredientID", id);
    MyAxios.delete(`Admin_Ingredients`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ترکیبات با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getAllIngredientList,
    getIngredientList,
    getIngredientByID,
    validate,
    updateIngredient,
    addIngredient,
    deleteIngredient,
    TransferIngredient,
    validateTransfer,
  };
}
